<svelte:options tag={null} />
  <script>
  export let id = undefined;
  export let style = undefined;
  export let className = undefined;
  export let fill = undefined;
  export let size = "3rem";
</script>

<svg aria-hidden="true" width={size} height={size} id={id}  style={style} class={className} fill={fill} xmlns="http://www.w3.org/2000/svg" viewBox="0 0 48 48"><path d="M17.78 23.53h6.81a4.91 4.91 0 00-1.45-3.62c-1.23-1.06-3.4-1.45-5.34-1.45s-4.25.43-5.49 1.57A5.22 5.22 0 0011 24a5.69 5.69 0 001.62 4.21c1.17 1 3.24 1.33 5.18 1.33s3.92-.31 5.15-1.32A5.38 5.38 0 0024.6 24h-6.82zM25 24v5.3h9.47A2.62 2.62 0 0037 26.68 2.69 2.69 0 0034.51 24zM36.83 21.1a2.41 2.41 0 00-2.4-2.42H25v4.86h9.55a2.45 2.45 0 002.28-2.44z"/><path d="M42 12v24H6V12h36m0-2H6a2 2 0 00-2 2v24a2 2 0 002 2h36a2 2 0 002-2V12a2 2 0 00-2-2z"/></svg>